import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { ConnectedSeminarHero } from './SeminarHero/SeminarHero';
import InstructorSlider from './InstructorSlider/InstructorSlider';
import UpcomingSeminars from './UpcomingSeminars/UpcomingSeminars';
import SeminarGallery from './SeminarGallery/SeminarGallery';
import RecommendedSeminars from './RecommendedSeminars/RecommendedSeminars';
import BreadCrumbMenu from '../../components/BreadCrumbMenus/';
import Placeholder from '../../components/Placeholder';
import { TABLET_P } from '../../constants';

/**
 * 「セミナー」画面 > 「セミナーのご案内」画面 > 一覧 > 各内容 > 詳細
 */
const SeminarPage = ({ copy, data, locale, location }) => (
  <React.Fragment>
    <ConnectedSeminarHero seminar={data} />
    <UpcomingSeminars seminars={data.seminars} />
    {/* <InstructorSlider
      instructors={data.seminars.map(seminar => seminar.instructor).filter(instructor => instructor.image)}
      copy={copy}
    />
    <SeminarGallery photos={data.photoGallery} disclaimers={data.disclaimers} copy={copy} />
    <RecommendedSeminars seminars={data.recommendedSeminars} /> */}
    {!(data && _.get(data, 'name') && _.get(data, 'slug') && _.get(data, 'breadcrumbs') && locale && location) ? (
      <Placeholder w="200px" h="24px" m={window.innerWidth > TABLET_P ? '0 0 20px 40px' : '0 0 20px 20px'} />
    ) : (
      <BreadCrumbMenu
        currentPath={`https://www.shiseido-professional.com/${locale}/education/${data.slug}`}
        items={[
          {
            name: 'TOP',
            path: `/${locale}/`,
          },
          {
            name: data.breadcrumbs.Breadcrumbs1.name,
            path: `/${locale}/education`,
          },
          {
            name: data.breadcrumbs.Breadcrumbs2.name,
            path: `/${locale}/seminar-schedule`,
          },
          {
            name: data.name.toUpperCase(),
            path: null,
          },
        ]}
      />
    )}
  </React.Fragment>
);

SeminarPage.defaultProps = {
  copy: {},
  data: {
    recommendedSeminars: [],
    seminars: [],
  },
};

SeminarPage.propTypes = {
  copy: PropTypes.shape(),
  data: PropTypes.shape(),
};

export default SeminarPage;



// WEBPACK FOOTER //
// ./src/pages/SeminarPage/SeminarPage.js